import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pantry-food-check-item" }
const _hoisted_2 = { class: "patry-food-check-item-text-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "patry-food-check-item-image-area",
      style: _ctx.styleImageArea,
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickFood(...args)))
    }, [
      _createVNode("img", {
        class: "patry-food-check-item-image",
        style: _ctx.styleImage,
        src: _ctx.getImage(),
        onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImageError(...args)))
      }, null, 44, ["src"]),
      _withDirectives(_createVNode("div", {
        class: "patry-food-check-item-check-image-area",
        style: _ctx.styleCheckImageArea
      }, [
        _createVNode("img", {
          ref: "checkImage",
          class: "patry-food-check-item-check-image",
          style: _ctx.styleImageArea
        }, null, 4)
      ], 4), [
        [_vShow, _ctx.isCheck]
      ])
    ], 4),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "patry-food-check-item-text",
        style: _ctx.styleText
      }, _toDisplayString(_ctx.getName()), 5)
    ])
  ]))
}